{
  "chart": "நோயாளர் பதிவேடு",
  "mrn": "MRN",
  "demographics": {
    "pageTitle": "பின்னணி விவரங்கள்",
    "loading": "நோயாளர் பின்னணி விவரங்களை ஏற்றுகிறது...",
    "loadError": "நோயாளர் பின்னணி விவரங்களை ஏற்ற முடியவில்லை.",
    "returnToDashboard": "டாஷ்போர்டுக்குத் திரும்பு",
    "updatedSuccess": "நோயாளர் பின்னணி விவரங்கள் புதுப்பிக்கப்பட்டன",
    "updateError": "நோயாளர் பின்னணி விவரங்களை புதுப்பிக்க முடியவில்லை",
    "sections": {
      "personalInformation": "தனிப்பட்ட தகவல்",
      "identification": "அடையாளம்",
      "contactInformation": "தொடர்பு தகவல்",
      "address": "முகவரி",
      "languageAndPreferences": "மொழி மற்றும் விருப்பத்தேர்வுகள்",
      "specialFlags": "சிறப்பு குறிகள்",
      "recordInformation": "பதிவு தகவல்"
    },
    "fields": {
      "fullName": "முழுப் பெயர்",
      "alternativeName": "மாற்றுப் பெயர்",
      "preferredName": "விருப்பப் பெயர்",
      "dateOfBirth": "பிறந்த தேதி",
      "birthTime": "பிறந்த நேரம்",
      "age": "வயது",
      "legalGender": "சட்டப்பூர்வ பாலினம்",
      "genderIdentity": "பாலின அடையாளம்",
      "sexAtBirth": "பிறப்பின்போதைய பாலினம்",
      "race": "இனம்",
      "ethnicity": "இனக்குழு",
      "nationality": "தேசியம்",
      "mrn": "MRN",
      "nationalIdType": "தேசிய அடையாள வகை",
      "nationalIdNumber": "தேசிய அடையாள எண்",
      "passportNumber": "கடவுச்சீட்டு எண்",
      "passportCountry": "கடவுச்சீட்டு வழங்கும் நாடு",
      "primaryPhone": "முதன்மை தொலைபேசி",
      "mobilePhone": "கைபேசி",
      "email": "மின்னஞ்சல்",
      "preferredContactMethod": "விருப்ப தொடர்பு முறை",
      "addressLine1": "முகவரி வரி 1",
      "addressLine2": "முகவரி வரி 2",
      "city": "நகரம்",
      "stateProvince": "மாநிலம்",
      "postalCode": "அஞ்சல் குறியீடு",
      "country": "நாடு",
      "primaryLanguage": "முதன்மை மொழி",
      "secondaryLanguage": "துணை மொழி",
      "interpreterRequired": "மொழிபெயர்ப்பாளர் தேவை",
      "vipStatus": "VIP நிலை",
      "confidentialityLevel": "இரகசியக் காப்பு நிலை",
      "medicalTourist": "மருத்துவ சுற்றுலா பயணி",
      "homeCountry": "சொந்த நாடு",
      "status": "நிலை",
      "deceased": "இறந்துவிட்டார்",
      "created": "உருவாக்கப்பட்டது",
      "lastModified": "கடைசியாக மாற்றப்பட்டது",
      "passportOnFile": "கடவுச்சீட்டு கோப்பில்",
      "organDonorStatus": "உறுப்பு தான நிலை"
    },
    "statusValues": {
      "active": "செயலில்",
      "inactive": "செயலற்ற"
    },
    "deceasedSummary": "ஆம் ({{date}})",
    "deceasedDateUnknown": "தேதி தெரியவில்லை",
    "legalGender": {
      "label": "சட்டப்பூர்வ பாலினம்",
      "values": {
        "male": "ஆண்",
        "female": "பெண்",
        "other": "மற்றவை",
        "unknown": "தெரியாது"
      },
      "selectPlaceholder": "பாலினத்தைத் தேர்வுசெய்க"
    },
    "sexAtBirth": {
      "label": "பிறப்பின்போதைய பாலினம்",
      "values": {
        "female": "பெண்",
        "male": "ஆண்",
        "other": "மற்றவை",
        "unknown": "தெரியவில்லை"
      },
      "notRecorded": "பதிவு இல்லை"
    },
    "preferredContactMethod": {
      "label": "விருப்ப தொடர்பு முறை",
      "values": {
        "phone": "தொலைபேசி",
        "mobile": "கைபேசி",
        "email": "மின்னஞ்சல்",
        "sms": "SMS"
      },
      "notSpecified": "குறிப்பிடப்படவில்லை"
    },
    "validation": {
      "fullNameRequired": "முழுப் பெயர் அவசியம்",
      "dateOfBirthRequired": "பிறந்த தேதி அவசியம்",
      "countryRequired": "நாடு அவசியம்",
      "primaryLanguageRequired": "முதன்மை மொழி அவசியம்",
      "invalidEmail": "தவறான மின்னஞ்சல்",
      "nationalIdValidationFailed": "தேசிய அடையாள சரிபார்ப்பு தோல்வி: {{error}}",
      "invalidBirthTime": "பிறந்த நேரம் HH:MM வடிவத்தில் இருக்க வேண்டும்"
    },
    "organDonor": {
      "notRecorded": "பதிவு இல்லை",
      "registered": "பதிவு செய்த தானி",
      "optedOut": "விலகல் தெரிவித்தார்",
      "notRegistered": "தானமாக பதிவு செய்யவில்லை",
      "unknown": "தெரியவில்லை"
    }
  },
  "registration": {
    "title": "நோயாளர் பதிவு",
    "subtitle": "புதிய நோயாளரை அமைப்பில் பதிவுசெய்க",
    "submit": "நோயாளரைப் பதிவுசெய்",
    "submitting": "பதிவு செய்யப்படுகிறது...",
    "checkingDuplicates": "நகல்களை சரிபார்க்கிறது...",
    "registerNew": "புதிய நோயாளர் பதிவு",
    "registeredSuccess": "நோயாளர் வெற்றிகரமாகப் பதிவுசெய்யப்பட்டார்",
    "registerError": "நோயாளர் பதிவு தோல்வியடைந்தது",
    "validationNationalIdFailed": "தேசிய அடையாள சரிபார்ப்பு தோல்வி: {{error}}",
    "sections": {
      "basicInformation": "அடிப்படை தகவல்",
      "identification": "அடையாளம்",
      "contactInformation": "தொடர்பு தகவல்",
      "address": "முகவரி",
      "languageAndCommunication": "மொழி மற்றும் தொடர்பாடல்",
      "additionalInformation": "கூடுதல் தகவல்"
    },
    "fields": {
      "facility": "பதிவு மையம்"
    },
    "placeholders": {
      "fullName": "எ.கா. கார்த்திக் சுந்தர் அல்லது 李小明",
      "alternativeName": "ரோமன் எழுத்துக்களில் (பொருந்தினால்)",
      "preferredName": "நோயாளர் அழைக்கப்பட விரும்பும் பெயர்",
      "nationalIdNumberDefault": "தேசிய அடையாள எண்ணை உள்ளிடவும்",
      "primaryPhone": "+91 98765 43210",
      "mobilePhone": "+91 98765 43210",
      "email": "patient@example.com",
      "facility": "மையத்தைத் தேர்ந்தெடுக்கவும்"
    },
    "helperText": {
      "fullName": "அதிகாரப்பூர்வ ஆவணங்களில் உள்ளபடி நோயாளரின் முழுப் பெயரை உள்ளிடவும்",
      "facility": "இந்த நோயாளி பதிவு செய்யப்படும் மையம். அந்த மையத்தின் பணியாளர்கள் இந்தப் பதிவைத் திறக்க முடியும்."
    },
    "flags": {
      "vipPatient": "VIP நோயாளர்",
      "medicalTourist": "மருத்துவ சுற்றுலா பயணி"
    },
    "duplicate": {
      "title": "நகல் வாய்ப்புள்ள நோயாளர்கள் கண்டறியப்பட்டனர்",
      "body": "பின்வரும் ஏற்கனவே உள்ள நோயாளர்கள் நீங்கள் உள்ளிட்ட தகவலுடன் பொருந்துகின்றனர்:",
      "mrnLabel": "MRN",
      "dobLabel": "DOB",
      "idLabel": "ID",
      "matchSummary": "பொருத்தம்: {{score}}% ({{reasons}})",
      "useExisting": "ஏற்கனவே உள்ளதைப் பயன்படுத்து",
      "createNew": "இது புதிய நோயாளர்",
      "restricted": {
        "title_one": "நீங்கள் பார்க்க முடியாத {{count}} சாத்தியமான பொருத்தம் உள்ளது",
        "title_other": "நீங்கள் பார்க்க முடியாத {{count}} சாத்தியமான பொருத்தங்கள் உள்ளன",
        "body": "இந்த நோயாளிக்கு வேறு மையத்தில் ஏற்கனவே பதிவு இருக்கலாம். புதிய பதிவை உருவாக்கும் முன் சுகாதாரத் தகவல் மேலாண்மைத் துறையைத் தொடர்பு கொள்ளவும் — அந்தப் பதிவு உங்கள் அணுகலுக்கு வெளியே இருப்பதால் விவரங்கள் காட்டப்படவில்லை."
      },
      "overrideReasonLabel": "இருப்பினும் பதிவு செய்வதற்கான காரணம்",
      "overrideReasonPlaceholder": "எ.கா. இது வேறு நபர் என நோயாளியிடம் உறுதிப்படுத்தப்பட்டது",
      "overrideReasonHelp": "உங்கள் கணக்கின் கீழ் பதிவு செய்யப்படும். ஒரே நபருக்கு இரண்டாவது பதிவை உருவாக்குவது அவர்களின் பதிவேட்டைப் பிரிக்கும்.",
      "registerAnyway": "இருப்பினும் பதிவு செய்"
    }
  },
  "search": {
    "title": "நோயாளர் தேடல்",
    "subtitle": "நோயாளர் பதிவுகளைத் தேடி நிர்வகிக்கவும்",
    "placeholder": "நோயாளர் பெயர், MRN அல்லது ID மூலம் தேடவும்...",
    "advancedFilters": "மேம்பட்ட வடிப்பான்கள்",
    "filters": {
      "mrnPlaceholder": "எ.கா. P0000000001",
      "fullNamePlaceholder": "நோயாளர் பெயர்",
      "phonePlaceholder": "தொலைபேசி எண்",
      "emailPlaceholder": "மின்னஞ்சல் முகவரி"
    },
    "filterLabels": {
      "mrn": "MRN",
      "fullName": "முழுப் பெயர்",
      "dateOfBirth": "பிறந்த தேதி",
      "phone": "தொலைபேசி",
      "email": "மின்னஞ்சல்",
      "country": "நாடு",
      "status": "நிலை",
      "vip": "VIP"
    },
    "vipFilter": {
      "all": "அனைத்தும்",
      "vipOnly": "VIP மட்டும்",
      "nonVipOnly": "VIP அல்லாதவை மட்டும்"
    },
    "statusFilter": {
      "all": "அனைத்தும்",
      "active": "செயலில்",
      "inactive": "செயலற்ற"
    },
    "countryFilter": {
      "all": "அனைத்து நாடுகளும்"
    },
    "clearFilters": "வடிப்பான்களை அழி",
    "dateOfBirthAria": "பிறந்த தேதி வடிப்பான்",
    "columns": {
      "mrn": "MRN",
      "fullName": "முழுப் பெயர்",
      "dob": "DOB",
      "gender": "பாலினம்",
      "phone": "தொலைபேசி",
      "country": "நாடு",
      "status": "நிலை"
    },
    "results": {
      "searching": "நோயாளர்களைத் தேடுகிறது...",
      "loadError": "நோயாளர்களை ஏற்ற முடியவில்லை. மீண்டும் முயலவும்.",
      "retry": "மீண்டும் முயலவும்",
      "empty": "நோயாளர் எவரும் கிடைக்கவில்லை. தேடல் அளவுகோல்களை மாற்றியமைக்கவும்.",
      "showing": "மொத்தம் {{total}} நோயாளர்களில் {{from}} – {{to}} காட்டப்படுகிறது"
    }
  },
  "myPatients": {
    "title": "என் நோயாளர்கள்",
    "subtitle": "உங்கள் கவனிப்பில் உள்ள நோயாளர்கள்",
    "searchPlaceholder": "பெயர் அல்லது MRN மூலம் வடிகட்டவும்...",
    "columns": {
      "mrn": "MRN",
      "patient": "முழுப் பெயர்",
      "dob": "DOB",
      "sex": "பாலினம்",
      "class": "வகை",
      "relationship": "உறவு",
      "admitted": "சேர்ந்த தேதி"
    },
    "kind": {
      "attending": "பொறுப்பு",
      "careTeam": "பராமரிப்பு குழு",
      "referral": "பரிந்துரை",
      "coverage": "பதில் பணி"
    },
    "restrictedBadge": "கட்டுப்பாடு",
    "empty": {
      "title": "உங்கள் பட்டியலில் நோயாளர்கள் இல்லை",
      "body": "நீங்கள் கவனிக்கும், பதிலாகப் பணியாற்றும் அல்லது பரிந்துரையில் பெறும் நோயாளர்கள் இங்கே தோன்றுவர்.",
      "censusAction": "படுக்கை பலகையைத் திறக்கவும்"
    },
    "results": {
      "searching": "உங்கள் நோயாளர்கள் ஏற்றப்படுகிறது...",
      "loadError": "உங்கள் நோயாளர்களை ஏற்ற முடியவில்லை. மீண்டும் முயலவும்.",
      "retry": "மீண்டும் முயலவும்",
      "showing": "மொத்தம் {{total}} நோயாளர்களில் {{from}} – {{to}} காட்டப்படுகிறது"
    }
  },
  "encounters": {
    "title": "வருகைகள்",
    "create": "வருகையை உருவாக்கு",
    "filters": "வடிப்பான்கள்",
    "filterLabels": {
      "status": "நிலை",
      "class": "வகை",
      "fromDate": "தொடக்க தேதி",
      "toDate": "முடிவு தேதி"
    },
    "filterPlaceholders": {
      "allStatuses": "அனைத்து நிலைகளும்",
      "allClasses": "அனைத்து வகைகளும்"
    },
    "clearFilters": "வடிப்பான்களை அழி",
    "fromDateAria": "தொடக்க தேதி",
    "toDateAria": "முடிவு தேதி",
    "columns": {
      "encounterNumber": "வருகை எண்",
      "class": "வகை",
      "status": "நிலை",
      "admitDate": "சேர்க்கப்பட்ட தேதி",
      "dischargeDate": "வீடு திரும்பிய தேதி",
      "location": "இடம்",
      "chiefComplaint": "முதன்மை புகார்"
    },
    "locationLabel": "இடம் #{{id}}",
    "loading": "வருகைகளை ஏற்றுகிறது...",
    "loadError": "வருகைகளை ஏற்ற முடியவில்லை.",
    "empty": "இந்த நோயாளருக்கு வருகைகள் எதுவும் இல்லை.",
    "showing": "மொத்தம் {{total}} இல் {{from}} – {{to}} காட்டப்படுகிறது"
  },
  "identifiers": {
    "nationalIdType": {
      "label": "தேசிய அடையாள வகை",
      "none": "இல்லை",
      "values": {
        "nric": "NRIC",
        "hkid": "HKID",
        "myKad": "MyKad",
        "aadhaar": "ஆதார்",
        "ktp": "KTP",
        "myNumber": "My Number",
        "thaiNationalId": "தாய் தேசிய அடையாள அட்டை"
      },
      "country": {
        "nric": "சிங்கப்பூர்",
        "hkid": "ஹாங்காங்",
        "myKad": "மலேசியா",
        "aadhaar": "இந்தியா",
        "ktp": "இந்தோனேசியா",
        "myNumber": "ஜப்பான்",
        "thaiNationalId": "தாய்லாந்து"
      },
      "placeholderByType": {
        "nric": "எ.கா. S1234567D",
        "myKad": "எ.கா. 850101-14-5678",
        "hkid": "எ.கா. A123456(3)",
        "aadhaar": "எ.கா. 2341 2341 2346",
        "thaiNationalId": "எ.கா. 1-2345-45678-78-1"
      }
    },
    "nationalIdCheck": {
      "checksumMismatch": "இந்த அடையாள வகைக்கான சரிபார்ப்பு எழுத்து பொருந்தவில்லை. நோயாளியின் அடையாள ஆவணத்துடன் எண்ணைச் சரிபார்க்கவும்.",
      "unavailable": "இந்த அடையாள எண்ணைச் சரிபார்க்க முடியவில்லை. நோயாளியின் அடையாள ஆவணத்துடன் எண்ணைச் சரிபார்க்கவும்.",
      "acknowledge": "இந்த எண்ணை அடையாள ஆவணத்துடன் சரிபார்த்துவிட்டேன்",
      "acknowledgeRequired": "சேமிப்பதற்கு முன் அடையாள ஆவணத்துடன் அடையாள எண்ணைச் சரிபார்த்து உறுதிப்படுத்தவும்."
    }
  },
  "country": {
    "values": {
      "sg": "சிங்கப்பூர்",
      "my": "மலேசியா",
      "th": "தாய்லாந்து",
      "id": "இந்தோனேசியா",
      "ph": "பிலிப்பீன்ஸ்",
      "vn": "வியட்நாம்",
      "hk": "ஹாங்காங்",
      "tw": "தைவான்",
      "jp": "ஜப்பான்",
      "kr": "தென் கொரியா",
      "cn": "சீனா",
      "in": "இந்தியா",
      "au": "ஆஸ்திரேலியா",
      "nz": "நியூசிலாந்து"
    }
  },
  "language": {
    "values": {
      "en": "ஆங்கிலம்",
      "zh": "சீனம் (மாண்டரின்)",
      "ms": "மலாய்",
      "ta": "தமிழ்",
      "th": "தாய்",
      "id": "இந்தோனேசியன்",
      "vi": "வியட்நாமீஸ்",
      "ja": "ஜப்பானியம்",
      "ko": "கொரியன்",
      "hi": "இந்தி"
    }
  },
  "contact": {
    "addTitle": "தொடர்பு சேர்",
    "editTitle": "தொடர்பைத் திருத்து",
    "name": "பெயர்",
    "relationship": {
      "label": "உறவு",
      "selectPlaceholder": "தேர்ந்தெடு...",
      "values": {
        "spouse": "வாழ்க்கைத் துணை",
        "parent": "பெற்றோர்",
        "child": "மகன்/மகள்",
        "sibling": "உடன்பிறந்தோர்",
        "guardian": "காப்பாளர்",
        "friend": "நண்பர்",
        "other": "மற்றவை"
      }
    },
    "phone": "தொலைபேசி",
    "email": "மின்னஞ்சல்",
    "emergencyContact": "அவசரத் தொடர்பு",
    "validation": {
      "nameRequired": "தொடர்பின் பெயர் தேவை",
      "relationshipRequired": "உறவு தேவை",
      "phoneRequired": "தொலைபேசி எண் தேவை",
      "invalidEmail": "தவறான மின்னஞ்சல்"
    },
    "savedSuccess": "தொடர்பு வெற்றிகரமாகச் சேர்க்கப்பட்டது",
    "saveError": "தொடர்பைச் சேர்க்க முடியவில்லை"
  },
  "immunization": {
    "addTitle": "தடுப்பூசி சேர்",
    "vaccineName": "தடுப்பூசியின் பெயர்",
    "vaccineNamePlaceholder": "எ.கா., இன்ஃப்ளுயன்ஸா, COVID-19 (Pfizer), ஹெபடைடிஸ் B",
    "vaccineCode": "தடுப்பூசிக் குறியீடு (CVX)",
    "vaccineCodePlaceholder": "எ.கா., 141",
    "administeredDate": "தடுப்பூசி போட்ட தேதி",
    "lotNumber": "தொகுதி எண்",
    "lotNumberPlaceholder": "எ.கா., AB1234",
    "site": {
      "label": "இடம்",
      "selectPlaceholder": "இடத்தைத் தேர்ந்தெடு",
      "values": {
        "leftDeltoid": "இடது டெல்டாய்டு",
        "rightDeltoid": "வலது டெல்டாய்டு",
        "leftThigh": "இடது தொடை",
        "rightThigh": "வலது தொடை",
        "leftGluteal": "இடது பின்புறம்",
        "rightGluteal": "வலது பின்புறம்",
        "other": "மற்றவை"
      }
    },
    "route": {
      "label": "வழி",
      "selectPlaceholder": "வழியைத் தேர்ந்தெடு",
      "values": {
        "intramuscular": "தசையினுள் (IM)",
        "subcutaneous": "தோலினுள் (SC)",
        "intradermal": "தோலுக்குள் (ID)",
        "oral": "வாய்வழி",
        "intranasal": "மூக்கு வழி"
      }
    },
    "doseAmount": "அளவு",
    "doseAmountPlaceholder": "எ.கா., 0.5 mL",
    "administeredBy": "வழங்கியவர்",
    "administeredByPlaceholder": "மருத்துவப் பணியாளர் பெயர் அல்லது ID",
    "nextDueDate": "அடுத்த தடுப்பூசித் தேதி",
    "notes": "குறிப்புகள்",
    "notesPlaceholder": "கூடுதல் குறிப்புகள்...",
    "validation": {
      "vaccineNameRequired": "தடுப்பூசியின் பெயர் தேவை",
      "administeredDateRequired": "தடுப்பூசி போட்ட தேதி தேவை"
    },
    "savedSuccess": "தடுப்பூசிப் பதிவு சேர்க்கப்பட்டது",
    "saveError": "தடுப்பூசிப் பதிவைச் சேர்க்க முடியவில்லை"
  },
  "insurance": {
    "addTitle": "காப்பீட்டுத் திட்டம் சேர்",
    "submitLabel": "காப்பீடு சேர்",
    "payerName": "பணம் செலுத்துபவர் பெயர்",
    "payerNamePlaceholder": "எ.கா., AIA சிங்கப்பூர்",
    "payerId": "பணம் செலுத்துபவர் ID",
    "payerIdPlaceholder": "பணம் செலுத்துபவர் அடையாளம்",
    "planName": "திட்டத்தின் பெயர்",
    "planNamePlaceholder": "எ.கா., HealthShield Gold Max",
    "planType": {
      "label": "திட்ட வகை",
      "selectPlaceholder": "வகையைத் தேர்ந்தெடு",
      "values": {
        "hmo": "HMO",
        "ppo": "PPO",
        "epo": "EPO",
        "pos": "POS",
        "government": "அரசு",
        "private": "தனியார்",
        "corporate": "நிறுவனம்",
        "other": "மற்றவை"
      }
    },
    "memberId": "உறுப்பினர் ID",
    "memberIdPlaceholder": "உறுப்பினர் ID எண்",
    "policyNumber": "பாலிசி எண்",
    "policyNumberPlaceholder": "பாலிசி எண்ணை உள்ளிடவும்",
    "groupNumber": "குழு எண்",
    "groupNumberPlaceholder": "குழு எண்",
    "subscriberName": "சந்தாதாரர் பெயர்",
    "subscriberNamePlaceholder": "நோயாளியிலிருந்து வேறுபட்டால்",
    "subscriberRelationship": {
      "label": "சந்தாதாரருடனான உறவு",
      "values": {
        "self": "தாமே",
        "spouse": "வாழ்க்கைத் துணை",
        "child": "மகன்/மகள்",
        "parent": "பெற்றோர்",
        "other": "மற்றவை"
      }
    },
    "priority": {
      "label": "முன்னுரிமை",
      "values": {
        "primary": "முதன்மை",
        "secondary": "இரண்டாம்",
        "tertiary": "மூன்றாம்"
      }
    },
    "effectiveDate": "நடைமுறை தேதி",
    "terminationDate": "முடிவுத் தேதி",
    "copayAmount": "இணை செலுத்தல் ($)",
    "coinsurancePercent": "இணை-காப்பீடு (%)",
    "deductibleAmount": "கழிவுத் தொகை ($)",
    "outOfPocketMax": "சொந்தச் செலவின் உச்சவரம்பு ($)",
    "preAuthRequired": "முன்-அனுமதி தேவை",
    "notes": "குறிப்புகள்",
    "notesPlaceholder": "கூடுதல் குறிப்புகள்...",
    "validation": {
      "payerNameRequired": "பணம் செலுத்துபவர் பெயர் தேவை",
      "planNameRequired": "திட்டத்தின் பெயர் தேவை",
      "memberIdRequired": "உறுப்பினர் ID தேவை",
      "effectiveDateRequired": "நடைமுறை தேதி தேவை"
    },
    "savedSuccess": "காப்பீட்டுத் திட்டம் சேர்க்கப்பட்டது",
    "saveError": "காப்பீட்டுத் திட்டத்தைச் சேர்க்க முடியவில்லை"
  },
  "problem": {
    "addTitle": "பிரச்சினையைச் சேர்",
    "problemName": "பிரச்சினையின் பெயர்",
    "problemNamePlaceholder": "எ.கா., வகை 2 நீரிழிவு நோய்",
    "icdCode": "ICD-10 குறியீடு",
    "icdSearchPlaceholder": "ICD-10 குறியீடு அல்லது விளக்கத்தைத் தேடு...",
    "onsetDate": "தொடக்கத் தேதி",
    "severity": {
      "label": "தீவிரம்",
      "values": {
        "mild": "மிதமான",
        "moderate": "நடுத்தர",
        "severe": "கடுமையான"
      }
    },
    "notes": "குறிப்புகள்",
    "notesPlaceholder": "கூடுதல் மருத்துவக் குறிப்புகள்...",
    "validation": {
      "problemNameRequired": "பிரச்சினையின் பெயர் தேவை"
    },
    "savedSuccess": "பிரச்சினைப் பட்டியலில் சேர்க்கப்பட்டது",
    "saveError": "பிரச்சினையைச் சேர்க்க முடியவில்லை"
  },
  "accounts": {
    "pageTitle": "நோயாளி கணக்குகள்",
    "backToDashboard": "டாஷ்போர்டு",
    "searchPatientLabel": "நோயாளியைத் தேடு",
    "searchPlaceholder": "பெயர் அல்லது MRN மூலம் தேடு...",
    "searching": "தேடுகிறது...",
    "noPatientsFound": "நோயாளிகள் இல்லை",
    "loadingAccount": "கணக்கை ஏற்றுகிறது...",
    "mrnLabel": "MRN",
    "generateStatement": "அறிக்கை உருவாக்கு",
    "statementComingSoon": "அறிக்கை உருவாக்கம் விரைவில் வரும்",
    "paymentPlan": "கட்டணத் திட்டம்",
    "paymentPlanComingSoon": "கட்டணத் திட்ட அமைப்பு விரைவில் வரும்",
    "totalCharges": "மொத்தக் கட்டணம்",
    "totalPayments": "மொத்தச் செலுத்துகை",
    "adjustments": "சரிசெய்தல்கள்",
    "outstandingBalance": "நிலுவை இருப்பு",
    "transactionHistory": "பரிவர்த்தனை வரலாறு",
    "columns": {
      "date": "தேதி",
      "type": "வகை",
      "description": "விளக்கம்",
      "amount": "தொகை",
      "balance": "இருப்பு"
    },
    "transactionType": {
      "label": "வகை",
      "values": {
        "charge": "கட்டணம்",
        "payment": "செலுத்துகை",
        "adjustment": "சரிசெய்தல்"
      }
    },
    "loadingTransactions": "பரிவர்த்தனைகளை ஏற்றுகிறது...",
    "noTransactionsFound": "பரிவர்த்தனைகள் இல்லை",
    "emptyState": "நோயாளியின் கணக்கைக் காண நோயாளியைத் தேடுங்கள்"
  },
  "proxies": {
    "title": "அங்கீகரிக்கப்பட்ட பிரதிநிதிகள்",
    "description": "இந்த நோயாளியின் போர்டல் தரவை அணுக அங்கீகரிக்கப்பட்ட பராமரிப்பாளர்கள், காப்பாளர்கள் மற்றும் சட்டப் பிரதிநிதிகள். ரத்து செய்யப்பட்ட பதிவுகள் தணிக்கைக்காக வைக்கப்படும்.",
    "addProxy": "பிரதிநிதி சேர்",
    "newRelationshipHeading": "புதிய பிரதிநிதி உறவு",
    "proxyUserId": "பிரதிநிதி பயனர் ID",
    "proxyUserIdPlaceholder": "பயனர் ID (நிர்வாகம் → பயனர்களில் இருந்து)",
    "proxyUserIdHelper": "நிர்வாகம் → பயனர்கள் பகுதியில் தேடுங்கள். பயனர் தேர்வுக் கூறு அடுத்த புதுப்பிப்பில் வரும்.",
    "relationship": {
      "label": "உறவு",
      "values": {
        "parent": "பெற்றோர்",
        "legalGuardian": "சட்டப்பூர்வ காப்பாளர்",
        "spousePartner": "வாழ்க்கைத் துணை / துணை",
        "adultChild": "வயது வந்த பிள்ளை",
        "powerOfAttorney": "அதிகாரப் பத்திர பிரதிநிதி",
        "healthcareAgent": "சுகாதாரப் பிரதிநிதி"
      }
    },
    "accessLevel": {
      "label": "அணுகல் நிலை",
      "values": {
        "full": "முழுமை",
        "limited": "வரம்புள்ள",
        "emergency": "அவசரம்"
      },
      "descriptions": {
        "full": "அனைத்து போர்டல் தரவும் — சந்திப்புகள், முடிவுகள், செய்திகள், படிவங்கள்.",
        "limited": "சந்திப்புகள் மற்றும் செய்திகள் மட்டும் (இளம் பருவத்தினருக்கு வழக்கமானது).",
        "emergency": "நோயாளி இயலாமை நிலையில் சுகாதாரப் பிரதிநிதிக்கான break-glass சமமான அணுகல்."
      }
    },
    "startDate": "தொடக்கத் தேதி",
    "endDate": "முடிவுத் தேதி",
    "startDateAria": "நடைமுறை தொடக்கத் தேதி",
    "endDateAria": "நடைமுறை முடிவுத் தேதி",
    "grantAccess": "பிரதிநிதி அணுகலை வழங்கு",
    "userIdRequired": "பிரதிநிதி பயனர் ID தேவை",
    "createdSuccess": "பிரதிநிதி உறவு உருவாக்கப்பட்டது",
    "duplicateError": "இந்த நபர் ஏற்கனவே அதே உறவில் பிரதிநிதியாக உள்ளார்",
    "invalidDataError": "தவறான பிரதிநிதி தரவு",
    "createError": "பிரதிநிதியை உருவாக்க முடியவில்லை",
    "revokedSuccess": "பிரதிநிதி அணுகல் ரத்து செய்யப்பட்டது",
    "revokeError": "பிரதிநிதியை ரத்து செய்ய முடியவில்லை",
    "emptyState": "பிரதிநிதிகள் கட்டமைக்கப்படவில்லை. மேலே உள்ள பொத்தானைப் பயன்படுத்தி பராமரிப்பாளர், காப்பாளர் அல்லது சுகாதாரப் பிரதிநிதிக்கு அணுகலை வழங்கவும்.",
    "sections": {
      "active": "செயலில் ({{count}})",
      "plannedInactive": "திட்டமிடப்பட்ட / செயலற்ற ({{count}})",
      "revoked": "ரத்து செய்யப்பட்டது ({{count}})"
    },
    "userIdFallback": "பயனர் #{{id}}",
    "noEndDate": "(முடிவுத் தேதி இல்லை)",
    "revokedOn": "{{date}} அன்று ரத்து",
    "revokeTitle": "பிரதிநிதி அணுகலை ரத்துசெய்",
    "confirmRevokeTitle": "பிரதிநிதி அணுகலை ரத்துசெய்ய வேண்டுமா?",
    "confirmRevokeBody": "{{name}} இந்த நோயாளியின் போர்டல் தரவை உடனடியாக அணுக முடியாது. பதிவு தணிக்கைத் தடயத்தில் இருக்கும்.",
    "confirmRevokeLabel": "அணுகலை ரத்துசெய்"
  },
  "merge": {
    "title": "நோயாளி இணைப்பு",
    "description": "நகல் நோயாளி பதிவுகளை இணைக்கவும். மூல நோயாளி செயலிழக்கச் செய்யப்படும், மற்றும் அனைத்து மருத்துவத் தரவும் இலக்கு (மீதம் உள்ள) நோயாளிக்கு மாற்றப்படும்.",
    "sourceLabel": "மூல நோயாளி (செயலிழக்கச் செய்யப்படும்)",
    "targetLabel": "இலக்கு நோயாளி (மீதம் உள்ள பதிவு)",
    "clearSelection": "தேர்வை அழி",
    "searchPlaceholder": "பெயர், MRN அல்லது தொலைபேசி மூலம் தேடு...",
    "fields": {
      "mrn": "MRN",
      "dob": "பிறந்த தேதி",
      "gender": "பாலினம்",
      "country": "நாடு",
      "phone": "தொலைபேசி",
      "email": "மின்னஞ்சல்"
    },
    "counts": {
      "encounters": "சந்திப்புகள்: {{count}}",
      "allergies": "ஒவ்வாமை: {{count}}",
      "problems": "பிரச்சினைகள்: {{count}}"
    },
    "samePatientWarning": "மூல மற்றும் இலக்கு வேறுபட்ட நோயாளிகளாக இருக்க வேண்டும்.",
    "comparisonTitle": "மக்கள்தொகை ஒப்பீடு",
    "comparisonSubtitle": "வேறுபாடுகள் அம்பர் நிறத்தில் முன்னிலைப்படுத்தப்பட்டுள்ளன.",
    "columns": {
      "field": "புலம்",
      "source": "மூலம் ({{mrn}})",
      "target": "இலக்கு ({{mrn}})"
    },
    "comparisonLabels": {
      "fullName": "முழுப் பெயர்",
      "mrn": "MRN",
      "dateOfBirth": "பிறந்த தேதி",
      "gender": "பாலினம்",
      "phone": "தொலைபேசி",
      "email": "மின்னஞ்சல்",
      "country": "நாடு",
      "nationalId": "தேசிய ID"
    },
    "reasonLabel": "இணைப்புக் காரணம்",
    "reasonPlaceholder": "இந்தப் பதிவுகளை இணைப்பதற்கான காரணம் (தேவை)",
    "notesLabel": "குறிப்புகள் (விருப்பத்தேர்வு)",
    "notesPlaceholder": "இந்த இணைப்பு பற்றிய கூடுதல் குறிப்புகள்",
    "mergeButton": "நோயாளிகளை இணை",
    "mergeSuccess": "நோயாளிகள் வெற்றிகரமாக இணைக்கப்பட்டனர்",
    "mergeError": "நோயாளிகளை இணைக்க முடியவில்லை",
    "successHeading": "இணைப்பு வெற்றிகரமாக முடிந்தது.",
    "successBodyPrefix": "நோயாளி {{mrn}} செயலிழக்கச் செய்யப்பட்டுள்ளார். அனைத்து மருத்துவத் தரவும் ",
    "successBodySuffix": " இற்கு மாற்றப்பட்டுள்ளது.",
    "confirmTitle": "நோயாளி இணைப்பை உறுதிசெய்",
    "confirmBodyPrefix": "இந்தச் செயலை ",
    "confirmBodyEmphasis": "மீட்க முடியாது",
    "confirmBodySuffix": ". நோயாளி {{sourceMrn}} ({{sourceName}}) செயலிழக்கச் செய்யப்படுவார், மற்றும் அனைத்து மருத்துவத் தரவும் நோயாளி {{targetMrn}} ({{targetName}}) இற்கு மாற்றப்படும்.",
    "confirmButton": "ஆம், நோயாளிகளை இணை",
    "swapSides": "Swap source and target",
    "preloadError": "Could not load the selected records.",
    "detailLoadError": "நோயாளர் பதிவை ஏற்ற முடியவில்லை."
  },
  "allergy": {
    "addTitle": "ஒவ்வாமை சேர்க்கவும்",
    "editTitle": "ஒவ்வாமையைத் திருத்தவும்",
    "allergen": "ஒவ்வாமை மூலம்",
    "allergenPlaceholder": "எ.கா. பெனிசிலின், நிலக்கடலை",
    "type": "வகை",
    "typeOptions": {
      "drug": "மருந்து",
      "food": "உணவு",
      "environmental": "சுற்றுச்சூழல்"
    },
    "severityLabel": "தீவிரத்தன்மை",
    "severity": {
      "mild": "லேசானது",
      "moderate": "மிதமானது",
      "severe": "கடுமையானது",
      "lifeThreatening": "உயிருக்கு ஆபத்தானது"
    },
    "reaction": "எதிர்வினை",
    "reactionPlaceholder": "எ.கா. தடிப்புத் தோல், அனஃபிலாக்சிஸ், குமட்டல்",
    "reactionOptions": {
      "rash": "சொறி",
      "hives": "தடிப்புத் தோல்",
      "anaphylaxis": "அனஃபிலாக்சிஸ்",
      "swelling": "வீக்கம்",
      "itching": "அரிப்பு",
      "other": "மற்றவை"
    },
    "onsetDate": "தொடக்கத் தேதி",
    "notes": "குறிப்புகள்",
    "notesPlaceholder": "கூடுதல் குறிப்புகள்...",
    "verifiedBy": "சரிபார்த்தவர்",
    "noKnownAllergies": "அறியப்பட்ட ஒவ்வாமைகள் இல்லை",
    "savedSuccess": "ஒவ்வாமை வெற்றிகரமாகச் சேர்க்கப்பட்டது",
    "saveError": "ஒவ்வாமையைச் சேர்க்க முடியவில்லை",
    "deletedSuccess": "ஒவ்வாமை அகற்றப்பட்டது"
  },
  "components": {
    "allergyBadge": {
      "title": "{{name}} ({{type}}) - {{severity}}"
    },
    "bradenScale": {
      "title": "பிரேடன் அளவீடு (அழுத்தக் காயம் ஆபத்து)",
      "footer": "மொத்த வரம்பு: 6-23. குறைந்த மதிப்பெண்கள் அழுத்தக் காயம் ஏற்படும் அதிக ஆபத்தைக் குறிக்கின்றன.",
      "scoreFormat": "மதிப்பெண்: {{score}} — {{riskBand}}",
      "riskBand": {
        "veryHigh": "மிக அதிக ஆபத்து",
        "high": "அதிக ஆபத்து",
        "moderate": "நடுத்தர ஆபத்து",
        "mild": "லேசான ஆபத்து",
        "none": "ஆபத்து இல்லை"
      },
      "subscales": {
        "sensoryPerception": {
          "label": "{{n}}. உணர்வுப் புலனுணர்வு",
          "options": {
            "1": "{{n}} - முழுமையாக மட்டுப்படுத்தப்பட்டது",
            "2": "{{n}} - மிகவும் மட்டுப்படுத்தப்பட்டது",
            "3": "{{n}} - சிறிது மட்டுப்படுத்தப்பட்டது",
            "4": "{{n}} - பாதிப்பு இல்லை"
          }
        },
        "moisture": {
          "label": "{{n}}. ஈரப்பதம்",
          "options": {
            "1": "{{n}} - தொடர்ந்து ஈரம்",
            "2": "{{n}} - மிகவும் ஈரம்",
            "3": "{{n}} - அவ்வப்போது ஈரம்",
            "4": "{{n}} - எப்போதாவது ஈரம்"
          }
        },
        "activity": {
          "label": "{{n}}. செயல்பாடு",
          "options": {
            "1": "{{n}} - படுக்கையில் முடங்கி",
            "2": "{{n}} - நாற்காலியில் முடங்கி",
            "3": "{{n}} - அவ்வப்போது நடக்கிறார்",
            "4": "{{n}} - அடிக்கடி நடக்கிறார்"
          }
        },
        "mobility": {
          "label": "{{n}}. நகர்வுத்திறன்",
          "options": {
            "1": "{{n}} - முற்றிலும் அசையமுடியாது",
            "2": "{{n}} - மிகவும் மட்டுப்படுத்தப்பட்டது",
            "3": "{{n}} - சிறிது மட்டுப்படுத்தப்பட்டது",
            "4": "{{n}} - வரம்பு இல்லை"
          }
        },
        "nutrition": {
          "label": "{{n}}. ஊட்டச்சத்து",
          "options": {
            "1": "{{n}} - மிக மோசம்",
            "2": "{{n}} - போதுமானதாக இல்லாமல் இருக்கலாம்",
            "3": "{{n}} - போதுமானது",
            "4": "{{n}} - மிகச் சிறந்தது"
          }
        },
        "frictionShear": {
          "label": "{{n}}. உராய்வு மற்றும் இடப்பெயர்ச்சி",
          "options": {
            "1": "{{n}} - பிரச்சினை உள்ளது",
            "2": "{{n}} - பிரச்சினை இருக்கலாம்",
            "3": "{{n}} - வெளிப்படையான பிரச்சினை இல்லை"
          }
        }
      }
    },
    "morseFallScale": {
      "title": "மோர்ஸ் வீழ்ச்சி அளவீடு",
      "scoreFormat": "மதிப்பெண்: {{score}} — {{riskBand}}",
      "subscales": {
        "historyOfFalling": {
          "label": "{{n}}. வீழ்ச்சி வரலாறு",
          "options": {
            "0": "இல்லை ({{score}})",
            "25": "உண்டு ({{score}})"
          }
        },
        "secondaryDiagnosis": {
          "label": "{{n}}. இரண்டாம் நிலை நோயறிதல்",
          "options": {
            "0": "இல்லை ({{score}})",
            "15": "உண்டு ({{score}})"
          }
        },
        "ambulatoryAid": {
          "label": "{{n}}. நடைபயிற்சி உதவி",
          "options": {
            "0": "எதுவுமில்லை / படுக்கையில் ஓய்வு / செவிலியர் உதவி ({{score}})",
            "15": "ஊன்றுகோல் / கைத்தடி / நடைபயிற்சி உதவி ({{score}})",
            "30": "மரச்சாமான்களை சார்ந்து ({{score}})"
          }
        },
        "ivHeparinLock": {
          "label": "{{n}}. நரம்பு வழி ஊசி / ஹெப்பாரின் பூட்டு",
          "options": {
            "0": "இல்லை ({{score}})",
            "20": "உண்டு ({{score}})"
          }
        },
        "gait": {
          "label": "{{n}}. நடை",
          "options": {
            "0": "இயல்பான / படுக்கையில் ஓய்வு / சக்கர நாற்காலி ({{score}})",
            "10": "பலவீனமான ({{score}})",
            "20": "பாதிக்கப்பட்ட ({{score}})"
          }
        },
        "mentalStatus": {
          "label": "{{n}}. மனநிலை",
          "options": {
            "0": "தனது திறமையை சரியாக அறிந்தவர் ({{score}})",
            "15": "அதிகமாக மதிப்பீடு / வரம்புகளை மறக்கிறார் ({{score}})"
          }
        }
      },
      "interventions": {
        "high": "அதிக ஆபத்து தலையீடுகள்: நிலையான வீழ்ச்சி தடுப்பு நடவடிக்கைகளை செயல்படுத்தவும். நோயாளியின் கையில் வீழ்ச்சி ஆபத்து கைபட்டை அணியவும். படுக்கைப் பக்கத்தில் வீழ்ச்சி ஆபத்து அறிவிப்பு வைக்கவும். நோயாளி மற்றும் குடும்பத்தினருக்கு கல்வி அளிக்கவும். படுக்கையை மிகக் குறைந்த நிலையில் வைத்து பிரேக்குகளை பூட்டவும். அழைப்பு விளக்கு எளிதில் எட்டக்கூடிய தூரத்தில் இருப்பதை உறுதி செய்யவும். நழுவல் தடுப்பு காலணி. கழிப்பறை அட்டவணை. தேவைப்பட்டால் 1:1 மேற்பார்வையை பரிசீலிக்கவும்.",
        "moderate": "நடுத்தர ஆபத்து தலையீடுகள்: நிலையான வீழ்ச்சி தடுப்பு நடவடிக்கைகளை செயல்படுத்தவும். நோயாளியின் கையில் வீழ்ச்சி ஆபத்து கைபட்டை அணியவும். நோயாளி மற்றும் குடும்பத்தினருக்கு கல்வி அளிக்கவும். படுக்கையை மிகக் குறைந்த நிலையில் வைத்து பிரேக்குகளை பூட்டவும். அழைப்பு விளக்கு எளிதில் எட்டக்கூடிய தூரத்தில் இருப்பதை உறுதி செய்யவும். நழுவல் தடுப்பு காலணி.",
        "low": "குறைந்த ஆபத்து தலையீடுகள்: நல்ல அடிப்படை செவிலியர் பராமரிப்பு. பாதுகாப்பான நகர்விற்கு நோயாளிக்கு கல்வி அளிக்கவும். சூழல் மற்றும் அழைப்பு விளக்கு பயன்பாட்டிற்கு வழிகாட்டவும்."
      }
    }
  },
  "banner": {
    "label": "நோயாளர் தகவல்",
    "vip": "VIP",
    "vipTitle": "VIP நோயாளர்",
    "mrn": "MRN",
    "dob": "DOB",
    "ageSuffix": "வ",
    "sex": "பாலினம்",
    "codeStatusAria": "குறியீட்டு நிலை: {{status}}",
    "isolationAria": "தனிமைப்படுத்தல்: {{status}}",
    "isolation": {
      "contact": "தொடர்பு",
      "droplet": "துளி",
      "airborne": "காற்று",
      "none": "இல்லை"
    },
    "fallRiskAria": "விழும் அபாயம்: {{level}}",
    "fallRisk": {
      "label": "விழும் அபாயம்",
      "low": "குறைவு",
      "moderate": "நடுத்தர",
      "high": "அதிக"
    },
    "pressureInjuryRisk": "அழுத்தக் காயம் ஆபத்து",
    "pressureInjuryRiskAria": "அழுத்தக் காயம் ஆபத்து: {{level}}",
    "interpreter": "மொழிபெயர்ப்பாளர்",
    "interpreterRequired": "மொழிபெயர்ப்பாளர் தேவை — {{language}}",
    "languageNotSpecified": "மொழி குறிப்பிடப்படவில்லை",
    "weightKg": "{{weight}} kg",
    "allergiesLabel": "ஒவ்வாமை",
    "moreAllergies_one": "+மேலும் {{count}}",
    "moreAllergies_other": "+மேலும் {{count}}",
    "nkda": "NKDA",
    "allergiesUnknown": "ஒவ்வாமை நிலை தெரியவில்லை — ஏற்ற முடியவில்லை"
  },
  "chartFrame": {
    "navAriaLabel": "நோயாளர் பதிவேடு வழிசெலுத்தல்",
    "tabs": {
      "summary": "சுருக்கம்",
      "encounters": "வருகைகள்",
      "orders": "ஆணைகள்",
      "results": "முடிவுகள்",
      "medications": "மருந்துகள்",
      "notes": "குறிப்புகள்",
      "problems": "பிரச்சினை பட்டியல்",
      "allergies": "ஒவ்வாமை",
      "immunizations": "தடுப்பூசிகள்",
      "intakeOutput": "உள்ளீடு/வெளியீடு",
      "carePlans": "பராமரிப்பு திட்டங்கள்",
      "referrals": "பரிந்துரைகள்",
      "familyHistory": "குடும்ப வரலாறு",
      "socialHistory": "சமூக வரலாறு",
      "surgicalHistory": "அறுவை சிகிச்சை வரலாறு",
      "advanceDirectives": "முன்னறிவிப்பு வழிகாட்டுதல்கள்",
      "insurance": "காப்பீடு",
      "contacts": "தொடர்புகள்",
      "proxies": "பிரதிநிதிகள்",
      "identifiers": "அடையாளங்கள்",
      "addresses": "முகவரிகள்",
      "consents": "Consents",
      "pregnancyStatus": "Pregnancy",
      "implantableDevices": "சாதனங்கள்",
      "ccdaImports": "C-CDA இறக்குமதி"
    },
    "groups": {
      "clinical": "மருத்துவ",
      "history": "வரலாறு",
      "admin": "நிர்வாகம்"
    },
    "breakGlass": {
      "auditBanner": "அவசரகால அணுகல் — அனைத்து செயல்பாடுகளும் தணிக்கை செய்யப்படுகின்றன. அணுகல் 15 நிமிடங்களில் காலாவதியாகும்.",
      "dialogTitle": "கட்டுப்படுத்தப்பட்ட நோயாளர் பதிவு",
      "dialogSubtitle": "அவசரகால அணுகல் தேவை",
      "dialogBody": "இந்த நோயாளர் பதிவு கட்டுப்படுத்தப்பட்டுள்ளது. அதை அணுக நீங்கள் காரணத்தை வழங்க வேண்டும். அனைத்து அவசரகால அணுகல்களும் பதிவு செய்யப்பட்டு தணிக்கை செய்யப்படுகின்றன.",
      "justificationLabel": "காரணம்",
      "justificationPlaceholder": "இந்த கட்டுப்படுத்தப்பட்ட பதிவை அணுகுவதற்கான மருத்துவ காரணத்தை உள்ளிடவும்...",
      "justificationRequired": "அவசரகால அணுகலுக்கு காரணம் தேவை.",
      "requestError": "அவசரகால அணுகல் கோரிக்கை தோல்வியடைந்தது. மீண்டும் முயலவும் அல்லது நிர்வாகியைத் தொடர்பு கொள்ளவும்.",
      "submitButton": "பதிவை அணுகு",
      "submitting": "கோரப்படுகிறது...",
      "passwordLabel": "உங்கள் கடவுச்சொல்லை உறுதிப்படுத்தவும்",
      "passwordPlaceholder": "உங்கள் கடவுச்சொல்லை மீண்டும் உள்ளிடவும்",
      "passwordRequired": "அவசரகால அணுகலுக்கு உங்கள் கடவுச்சொல் தேவை.",
      "passwordIncorrect": "கடவுச்சொல் தவறானது. மீண்டும் முயலவும்.",
      "passwordHelp": "இந்தப் பணிநிலையத்தில் இருப்பது நீங்கள்தான் என்பதை உறுதிப்படுத்துகிறது.",
      "totpLabel": "அங்கீகரிப்புக் குறியீடு",
      "totpPlaceholder": "6 இலக்கக் குறியீடு",
      "totpRequired": "அவசரகால அணுகலுக்கு உங்கள் அங்கீகரிப்புக் குறியீடு தேவை.",
      "totpIncorrect": "குறியீடு தவறானது. மீண்டும் முயலவும்.",
      "totpHelp": "இந்தப் பணிநிலையத்தில் இருப்பது நீங்கள்தான் என்பதை உறுதிப்படுத்துகிறது.",
      "totpEnrollHint": "அங்கீகரிப்புச் செயலி எதுவும் பதிவு செய்யப்படவில்லை — அவசரகால அணுகலைப் பயன்படுத்த உங்கள் சுயவிவரத்தில் பதிவு ச்ய்யவும்."
    },
    "invalidId": {
      "title": "தவறான நோயாளர் ID",
      "body": "வழங்கப்பட்ட நோயாளர் ID செல்லுபடியாகாது.",
      "action": "நோயாளர்களைத் தேடு"
    },
    "notFound": {
      "title": "நோயாளர் கிடைக்கவில்லை",
      "body": "நோயாளர் தரவை ஏற்ற முடியவில்லை. நோயாளர் இல்லாமல் இருக்கலாம் அல்லது உங்களுக்கு அணுகல் இல்லாமல் இருக்கலாம்.",
      "action": "நோயாளர்களைத் தேடு"
    },
    "loadError": {
      "title": "நோயாளர் விளக்கப்படத்தை ஏற்ற முடியவில்லை",
      "body": "விளக்கப்படத்தை ஏற்ற முடியவில்லை. மீண்டும் முயல்க.",
      "action": "மீண்டும் முயல்க"
    }
  },
  "address": {
    "title": "முகவரிகள்",
    "addAddress": "முகவரியைச் சேர்",
    "newTitle": "புதிய முகவரி",
    "editTitle": "முகவரியைத் திருத்து",
    "loading": "முகவரிகள் ஏற்றப்படுகின்றன...",
    "loadError": "முகவரித் தகவலை ஏற்ற முடியவில்லை.",
    "empty": "முகவரிகள் எதுவும் இல்லை.",
    "addressType": {
      "label": "வகை",
      "values": {
        "home": "வீடு",
        "work": "வேலையிடம்",
        "temporary": "தற்காலிக",
        "billing": "பில்லிங்"
      }
    },
    "fields": {
      "addressLine1": "முகவரி வரி 1",
      "addressLine2": "முகவரி வரி 2",
      "addressLine3": "முகவரி வரி 3",
      "district": "மாவட்டம்",
      "city": "நகரம்",
      "stateProvince": "மாநிலம்",
      "postalCode": "அஞ்சல் குறியீடு",
      "country": "நாடு"
    },
    "placeholders": {
      "addressLine1": "தெரு முகவரி",
      "addressLine2": "அபார்ட்மென்ட், அலகு, தளம்",
      "addressLine3": "கட்டிடம், பிளாக்",
      "district": "மாவட்டம்/தாலுகா",
      "postalCode": "எ.கா. 600001",
      "country": "எ.கா. IN"
    },
    "primaryBadge": "முதன்மை",
    "setPrimary": "முதன்மை முகவரியாக அமை",
    "primaryHelper": "(மற்ற முகவரிகள் முதன்மை அல்லாமல் ஆகும்)",
    "fromLabel": "முதல்: {{date}}",
    "toLabel": "வரை: {{date}}",
    "save": "சேமி",
    "update": "புதுப்பி",
    "cancel": "ரத்து",
    "editTooltip": "முகவரியைத் திருத்து",
    "removeTooltip": "முகவரியை அகற்று",
    "addedSuccess": "முகவரி சேர்க்கப்பட்டது",
    "addError": "முகவரியைச் சேர்க்க முடியவில்லை",
    "updatedSuccess": "முகவரி புதுப்பிக்கப்பட்டது",
    "updateError": "முகவரியைப் புதுப்பிக்க முடியவில்லை",
    "removedSuccess": "முகவரி அகற்றப்பட்டது",
    "removeError": "முகவரியை அகற்ற முடியவில்லை",
    "requiredError": "முகவரி வரி 1 மற்றும் நாடு கட்டாயம்",
    "confirmRemoveTitle": "முகவரியை அகற்று",
    "confirmRemoveMessage": "இந்த {{type}} முகவரியை அகற்ற விரும்புகிறீர்களா?",
    "confirmRemoveLabel": "அகற்று"
  },
  "allergies": {
    "pageTitle": "ஒவ்வாமைகள்",
    "addAllergy": "ஒவ்வாமையைச் சேர்",
    "loading": "ஒவ்வாமைகள் ஏற்றப்படுகின்றன...",
    "loadError": "ஒவ்வாமைத் தகவலை ஏற்ற முடியவில்லை.",
    "nka": {
      "title": "அறியப்பட்ட ஒவ்வாமை இல்லை (NKA)",
      "body": "இந்த நோயாளிக்கு ஒவ்வாமைகள் எதுவும் பதிவாகவில்லை."
    },
    "sections": {
      "active": "செயலில் உள்ள ஒவ்வாமைகள் ({{count}})",
      "inactive": "செயலற்ற ஒவ்வாமைகள் ({{count}})"
    },
    "fields": {
      "reaction": "எதிர்வினை",
      "severity": "தீவிரம்",
      "onset": "தொடக்கம்",
      "recorded": "பதிவு தேதி"
    },
    "inactiveSummary": "எதிர்வினை: {{reaction}} | தீவிரம்: {{severity}}",
    "deactivate": "செயல்நீக்கு",
    "deactivateTooltip": "ஒவ்வாமையைச் செயல்நீக்கு",
    "deleteTooltip": "ஒவ்வாமையை நீக்கு",
    "deactivatedSuccess": "ஒவ்வாமை செயல்நீக்கப்பட்டது",
    "deactivateError": "ஒவ்வாமையைச் செயல்நீக்க முடியவில்லை",
    "removedSuccess": "ஒவ்வாமை அகற்றப்பட்டது",
    "removeError": "ஒவ்வாமையை அகற்ற முடியவில்லை",
    "confirmDeactivateTitle": "செயல்நீக்கம் உறுதிப்படுத்தல்",
    "confirmDeactivateMessage": "\"{{name}}\" ஐச் செயல்நீக்க விரும்புகிறீர்களா?",
    "confirmDeleteTitle": "நீக்கம் உறுதிப்படுத்தல்",
    "confirmDeleteMessage": "\"{{name}}\" ஐ நிரந்தரமாக நீக்க விரும்புகிறீர்களா?",
    "confirmLabel": "உறுதிப்படுத்து"
  },
  "problems": {
    "pageTitle": "சிக்கல் பட்டியல்",
    "addProblem": "சிக்கலைச் சேர்",
    "loading": "சிக்கல் பட்டியல் ஏற்றப்படுகிறது...",
    "loadError": "சிக்கல் பட்டியலை ஏற்ற முடியவில்லை.",
    "tabs": {
      "active": "செயலில் ({{count}})",
      "resolvedInactive": "தீர்க்கப்பட்டது / செயலற்றது ({{count}})"
    },
    "sortByLabel": "வரிசைப்படுத்து:",
    "sortBy": {
      "onsetDate": "தொடக்க தேதி",
      "severity": "தீவிரம்"
    },
    "status": {
      "label": "நிலை",
      "values": {
        "active": "செயலில்",
        "resolved": "தீர்க்கப்பட்டது",
        "inactive": "செயலற்றது"
      }
    },
    "empty": {
      "active": "செயலில் உள்ள சிக்கல்கள் எதுவும் பதிவாகவில்லை.",
      "resolved": "தீர்க்கப்பட்ட அல்லது செயலற்ற சிக்கல்கள் இல்லை."
    },
    "fields": {
      "onset": "தொடக்கம்",
      "resolved": "தீர்வு"
    },
    "resolveButton": "தீர்க்கப்பட்டது",
    "reactivateButton": "மீண்டும் செயல்படுத்து",
    "resolveTooltip": "தீர்க்கப்பட்டதாகக் குறி",
    "reactivateTooltip": "மீண்டும் செயல்படுத்து",
    "statusUpdatedSuccess": "சிக்கல் நிலை புதுப்பிக்கப்பட்டது",
    "statusUpdateError": "சிக்கல் நிலையைப் புதுப்பிக்க முடியவில்லை"
  },
  "immunizations": {
    "pageTitle": "தடுப்பூசிகள்",
    "addImmunization": "தடுப்பூசியைச் சேர்",
    "loading": "தடுப்பூசிப் பதிவுகள் ஏற்றப்படுகின்றன...",
    "loadError": "தடுப்பூசிப் பதிவுகளை ஏற்ற முடியவில்லை.",
    "empty": "தடுப்பூசிப் பதிவுகள் எதுவும் கிடைக்கவில்லை.",
    "dueOverdue": "செலுத்த வேண்டிய / தாமதமான தடுப்பூசிகள் ({{count}})",
    "upcoming": "வரவிருக்கும் தடுப்பூசிகள் ({{count}})",
    "dueLabel": "செலுத்த: {{date}}",
    "fromDateLabel": "தொடக்க தேதி",
    "toDateLabel": "முடிவு தேதி",
    "fromDateAria": "தடுப்பூசி தொடக்க தேதி",
    "toDateAria": "தடுப்பூசி முடிவு தேதி",
    "clearFilters": "அழி",
    "cvxLabel": "CVX: {{code}}",
    "columns": {
      "vaccine": "தடுப்பூசி",
      "date": "தேதி",
      "lotNumber": "லாட் எண்",
      "site": "இடம்",
      "administeredBy": "வழங்கியவர்",
      "nextDue": "அடுத்த தேதி",
      "status": "நிலை"
    },
    "dueStatus": {
      "label": "நிலை",
      "values": {
        "overdue": "தாமதம்",
        "dueToday": "இன்று செலுத்த",
        "upcoming": "வரவிருக்கிறது"
      }
    }
  },
  "contacts": {
    "pageTitle": "தொடர்புகள்",
    "addContact": "தொடர்பைச் சேர்",
    "loading": "தொடர்புகள் ஏற்றப்படுகின்றன...",
    "loadError": "தொடர்புத் தகவலை ஏற்ற முடியவில்லை.",
    "empty": "தொடர்புகள் எதுவும் இல்லை.",
    "emergencyBadge": "அவசரம்",
    "sections": {
      "emergency": "அவசரத் தொடர்புகள் ({{count}})",
      "other": "மற்ற தொடர்புகள் ({{count}})"
    },
    "editTooltip": "தொடர்பைத் திருத்து",
    "deleteTooltip": "தொடர்பை நீக்கு",
    "deletedSuccess": "தொடர்பு நீக்கப்பட்டது",
    "deleteError": "தொடர்பை நீக்க முடியவில்லை",
    "confirmDeleteTitle": "தொடர்பை நீக்கு",
    "confirmDeleteMessage": "\"{{name}}\" ஐ நீக்க விரும்புகிறீர்களா?",
    "confirmDeleteLabel": "நீக்கு"
  },
  "insurances": {
    "pageTitle": "காப்பீடு",
    "addInsurance": "காப்பீட்டைச் சேர்",
    "loading": "காப்பீட்டுத் தகவல் ஏற்றப்படுகிறது...",
    "loadError": "காப்பீட்டுத் தகவலை ஏற்ற முடியவில்லை.",
    "empty": {
      "title": "காப்பீட்டுத் திட்டங்கள் இல்லை",
      "body": "இந்த நோயாளிக்குக் காப்பீட்டுத் திட்டங்கள் எதுவும் பதிவாகவில்லை."
    },
    "sections": {
      "active": "செயலில் உள்ள திட்டங்கள் ({{count}})",
      "inactive": "செயலற்ற திட்டங்கள் ({{count}})"
    },
    "status": {
      "label": "நிலை",
      "values": {
        "active": "செயலில்",
        "inactive": "செயலற்றது",
        "pendingVerification": "சரிபார்ப்பு நிலுவை"
      }
    },
    "fields": {
      "memberId": "உறுப்பினர் ID",
      "groupNumber": "குழு எண்",
      "effectiveDate": "நடைமுறை தேதி",
      "terminationDate": "முடிவு தேதி",
      "copay": "காப்பீட்டுச் செலவு",
      "coinsurance": "இணை-காப்பீடு",
      "deductible": "கழிக்கத்தக்கது",
      "subscriber": "சந்தாதாரர்"
    },
    "preAuthBadge": "முன் அனுமதி தேவை",
    "lastVerifiedLabel": "கடைசியாக சரிபார்க்கப்பட்டது: {{date}}",
    "copayAmount": "${{amount}}",
    "coinsurancePercent": "{{percent}}%",
    "deductibleAmount": "${{amount}}",
    "verifyButton": "சரிபார்",
    "verifyTooltip": "தகுதியைச் சரிபார்",
    "editButton": "திருத்து",
    "verifySuccess": "தகுதிச் சரிபார்ப்பு தொடங்கப்பட்டது",
    "verifyError": "தகுதிச் சரிபார்ப்பு தோல்வி"
  },
  "identifiersTab": {
    "pageTitle": "அடையாளங்கள்",
    "addIdentifier": "அடையாளத்தைச் சேர்",
    "loading": "அடையாளங்கள் ஏற்றப்படுகின்றன...",
    "loadError": "அடையாளத் தகவலை ஏற்ற முடியவில்லை.",
    "empty": "அடையாளங்கள் எதுவும் இல்லை.",
    "newTitle": "புதிய அடையாளம்",
    "type": {
      "label": "வகை",
      "selectPlaceholder": "வகையைத் தேர்வு செய்...",
      "values": {
        "externalMrn": "வெளி MRN",
        "insuranceId": "காப்பீட்டு ID",
        "studyId": "ஆய்வு ID",
        "healthCard": "சுகாதார அட்டை",
        "nationalRegistry": "தேசிய பதிவு",
        "passport": "கடவுச்சீட்டு",
        "driverLicense": "ஓட்டுநர் உரிமம்",
        "other": "மற்றவை"
      }
    },
    "fields": {
      "value": "மதிப்பு",
      "assigningAuthority": "வழங்கும் அதிகாரம்",
      "effectiveDate": "நடைமுறை தேதி",
      "expiryDate": "காலாவதி தேதி"
    },
    "placeholders": {
      "value": "எ.கா. 2341 2341 2346",
      "assigningAuthority": "எ.கா. UIDAI"
    },
    "status": {
      "label": "நிலை",
      "values": {
        "active": "செயலில்",
        "inactive": "செயலற்றது"
      }
    },
    "columns": {
      "type": "வகை",
      "value": "மதிப்பு",
      "assigningAuthority": "வழங்கும் அதிகாரம்",
      "effectiveDate": "நடைமுறை தேதி",
      "expiryDate": "காலாவதி தேதி",
      "status": "நிலை",
      "actions": "செயல்கள்"
    },
    "save": "சேமி",
    "cancel": "ரத்து",
    "removeTooltip": "அடையாளத்தை அகற்று",
    "addedSuccess": "அடையாளம் சேர்க்கப்பட்டது",
    "addError": "அடையாளத்தைச் சேர்க்க முடியவில்லை",
    "removedSuccess": "அடையாளம் அகற்றப்பட்டது",
    "removeError": "அடையாளத்தை அகற்ற முடியவில்லை",
    "requiredError": "வகை மற்றும் மதிப்பு கட்டாயம்",
    "confirmRemoveTitle": "அடையாளத்தை அகற்று",
    "confirmRemoveMessage": "\"{{type}}: {{value}}\" ஐ அகற்ற விரும்புகிறீர்களா?",
    "confirmRemoveLabel": "அகற்று"
  },
  "pages": {
    "advanceDirectives": {
      "title": "முன்னேற்பாட்டு மருத்துவ வழிகாட்டுதல்கள்",
      "addButton": "வழிகாட்டுதல் சேர்",
      "emptyState": "இந்த நோயாளிக்கு எந்த முன்னேற்பாட்டு மருத்துவ வழிகாட்டுதலும் பதிவு செய்யப்படவில்லை.",
      "loading": "முன்னேற்பாட்டு மருத்துவ வழிகாட்டுதல்கள் ஏற்றப்படுகின்றன...",
      "loadError": "முன்னேற்பாட்டு மருத்துவ வழிகாட்டுதல்களை ஏற்ற முடியவில்லை.",
      "documentLink": "ஆவணத்தைக் காண்க",
      "effectivePrefix": "செயல்படும்:",
      "reviewPrefix": "மறுபரிசீலனை:",
      "form": {
        "title": "புதிய முன்னேற்பாட்டு மருத்துவ வழிகாட்டுதல்",
        "labels": {
          "directiveType": "வழிகாட்டுதல் வகை",
          "status": "நிலை",
          "effectiveDate": "செயல்படும் தேதி",
          "notes": "குறிப்புகள்",
          "optional": "விருப்பத்தேர்வு"
        },
        "placeholders": {
          "notes": "வழிகாட்டுதல் தொடர்பான கூடுதல் குறிப்புகள்..."
        },
        "selectTypePlaceholder": "வகையைத் தேர்வுசெய்க...",
        "aria": {
          "effectiveDate": "செயல்படும் தேதி"
        },
        "buttons": {
          "save": "வழிகாட்டுதலைச் சேமி",
          "cancel": "ரத்து"
        }
      },
      "directiveType": {
        "DNR": "மீட்க வேண்டாம் (DNR)",
        "living-will": "வாழ்நாள் சாசனம்",
        "POLST": "POLST / MOLST",
        "healthcare-proxy": "சுகாதார பிரதிநிதி",
        "power-of-attorney": "நிலையான அதிகாரப்பத்திரம்"
      },
      "directiveStatus": {
        "active": "செயலில்",
        "inactive": "செயலற்ற",
        "revoked": "ரத்துசெய்யப்பட்டது",
        "pending": "மறுபரிசீலனை நிலுவையில்"
      },
      "toast": {
        "added": "முன்னேற்பாட்டு மருத்துவ வழிகாட்டுதல் சேர்க்கப்பட்டது",
        "addFailed": "முன்னேற்பாட்டு மருத்துவ வழிகாட்டுதலைச் சேர்க்க முடியவில்லை",
        "directiveTypeRequired": "வழிகாட்டுதல் வகை கட்டாயம்"
      }
    },
    "familyHistory": {
      "title": "குடும்ப வரலாறு",
      "addButton": "உள்ளீட்டைச் சேர்",
      "emptyState": "இந்த நோயாளிக்கு குடும்ப வரலாறு பதிவு செய்யப்படவில்லை.",
      "loading": "குடும்ப வரலாறு ஏற்றப்படுகிறது...",
      "loadError": "குடும்ப வரலாற்றை ஏற்ற முடியவில்லை.",
      "onsetAge": "தொடக்க வயது: {{age}} ஆண்டுகள்",
      "outcomePrefix": "முடிவு:",
      "form": {
        "title": "புதிய குடும்ப வரலாறு உள்ளீடு",
        "labels": {
          "relationship": "உறவு",
          "conditionName": "நோய் பெயர்",
          "conditionCode": "நோய் குறியீடு",
          "onsetAge": "தொடக்க வயது",
          "outcome": "முடிவு",
          "optional": "விருப்பத்தேர்வு"
        },
        "placeholders": {
          "onsetAge": "ஆண்டுகளில் வயது"
        },
        "selectRelationshipPlaceholder": "உறவைத் தேர்ந்தெடுக்கவும்...",
        "selectOutcomePlaceholder": "முடிவைத் தேர்ந்தெடுக்கவும்...",
        "buttons": {
          "save": "உள்ளீட்டைச் சேமி",
          "cancel": "ரத்துசெய்"
        }
      },
      "relationship": {
        "Mother": "தாய்",
        "Father": "தந்தை",
        "Sibling": "உடன்பிறப்பு",
        "Maternal Grandmother": "தாய்வழி பாட்டி",
        "Maternal Grandfather": "தாய்வழி தாத்தா",
        "Paternal Grandmother": "தந்தைவழி பாட்டி",
        "Paternal Grandfather": "தந்தைவழி தாத்தா",
        "Child": "குழந்தை",
        "Aunt": "சித்தி/அத்தை",
        "Uncle": "மாமா/சித்தப்பா/பெரியப்பா"
      },
      "outcome": {
        "alive": "உயிருடன்",
        "deceased": "இறந்தவர்",
        "unknown": "தெரியவில்லை"
      },
      "toast": {
        "added": "குடும்ப வரலாறு உள்ளீடு சேர்க்கப்பட்டது",
        "addFailed": "குடும்ப வரலாறு உள்ளீட்டைச் சேர்க்க முடியவில்லை",
        "relationshipAndConditionRequired": "உறவு மற்றும் நோய் பெயர் கட்டாயம்"
      }
    },
    "socialHistory": {
      "title": "சமூக வரலாறு",
      "editButton": "திருத்து",
      "loading": "சமூக வரலாறு ஏற்றப்படுகிறது...",
      "loadError": "சமூக வரலாற்றை ஏற்றுவதில் தோல்வி.",
      "labels": {
        "smokingStatus": "புகைபிடித்தல் நிலை",
        "alcoholUse": "மது பயன்பாடு",
        "substanceUse": "போதைப்பொருள் பயன்பாடு",
        "housing": "வீட்டுவசதி",
        "employment": "வேலைவாய்ப்பு",
        "safetyScreening": "பாதுகாப்பு திரையிடல்",
        "notes": "குறிப்புகள்"
      },
      "placeholders": {
        "notes": "கூடுதல் குறிப்புகள்..."
      },
      "buttons": {
        "save": "மாற்றங்களை சேமி",
        "cancel": "ரத்துசெய்"
      },
      "toast": {
        "updated": "சமூக வரலாறு புதுப்பிக்கப்பட்டது",
        "updateFailed": "சமூக வரலாற்றை புதுப்பிக்க முடியவில்லை"
      },
      "smokingStatus": {
        "never": "எப்போதும் புகைபிடிக்காதவர்",
        "former": "முன்னாள் புகைப்பிடிப்பவர்",
        "currentDaily": "தற்போது தினமும் புகைபிடிப்பவர்",
        "currentOccasional": "தற்போது அவ்வப்போது புகைபிடிப்பவர்",
        "unknown": "தெரியாது"
      },
      "alcoholUse": {
        "None": "இல்லை",
        "Social/Occasional": "சமூகம்/அவ்வப்போது",
        "Moderate": "மிதமான",
        "Heavy": "அதிக",
        "In Recovery": "குணமடைகிறார்",
        "Unknown": "தெரியாது"
      },
      "substanceUse": {
        "None": "இல்லை",
        "Current Use": "தற்போதைய பயன்பாடு",
        "Former Use": "முன்னாள் பயன்பாடு",
        "In Treatment": "சிகிச்சையில்",
        "Unknown": "தெரியாது"
      },
      "housing": {
        "Stable": "நிலையான",
        "Unstable": "நிலையற்ற",
        "Homeless": "வீடற்ற",
        "Assisted Living": "உதவியுடன் வாழ்க்கை",
        "Nursing Facility": "பராமரிப்பு வசதி",
        "Unknown": "தெரியாது"
      },
      "employment": {
        "Employed Full-Time": "முழுநேர பணி",
        "Employed Part-Time": "பகுதிநேர பணி",
        "Self-Employed": "சுயதொழில்",
        "Unemployed": "வேலையற்ற",
        "Retired": "ஓய்வுபெற்ற",
        "Student": "மாணவர்",
        "Disabled": "ஊனம் காரணமாக பணியற்ற",
        "Unknown": "தெரியாது"
      },
      "safetyScreening": {
        "No Concerns": "கவலைகள் இல்லை",
        "Concerns Identified": "கவலைகள் கண்டறியப்பட்டன",
        "Declined to Answer": "பதிலளிக்க மறுத்தார்",
        "Not Screened": "திரையிடப்படவில்லை"
      }
    },
    "surgicalHistory": {
      "title": "அறுவை சிகிச்சை வரலாறு",
      "addButton": "செயல்முறையை சேர்",
      "emptyState": "இந்த நோயாளிக்கு அறுவை சிகிச்சை வரலாறு பதிவு செய்யப்படவில்லை.",
      "loading": "அறுவை சிகிச்சை வரலாறு ஏற்றப்படுகிறது...",
      "loadError": "அறுவை சிகிச்சை வரலாற்றை ஏற்ற முடியவில்லை.",
      "cptLabel": "CPT {{code}}",
      "dateLabel": "தேதி: {{date}}",
      "surgeonLabel": "அறுவை சிகிச்சை நிபுணர்: {{name}}",
      "anesthesiaLabel": "மயக்க மருந்து: {{type}}",
      "outcomePrefix": "முடிவு:",
      "complicationsPrefix": "சிக்கல்கள்:",
      "form": {
        "title": "புதிய அறுவை சிகிச்சை வரலாறு உள்ளீடு",
        "labels": {
          "procedureName": "செயல்முறை பெயர்",
          "procedureCode": "செயல்முறை குறியீடு",
          "procedureCodeSuffix": "(CPT)",
          "date": "தேதி",
          "surgeonName": "அறுவை சிகிச்சை நிபுணரின் பெயர்",
          "anesthesiaType": "மயக்க மருந்து வகை",
          "laterality": "பக்கம்",
          "outcome": "முடிவு",
          "complications": "சிக்கல்கள்"
        },
        "placeholders": {
          "surgeonName": "அறுவை சிகிச்சை நிபுணரின் பெயர்",
          "complications": "சிக்கல்கள் இருந்தால்..."
        },
        "selectPlaceholder": "தேர்ந்தெடு...",
        "aria": {
          "procedureDate": "செயல்முறை தேதி"
        },
        "buttons": {
          "save": "உள்ளீட்டை சேமி",
          "cancel": "ரத்து செய்"
        }
      },
      "anesthesiaType": {
        "general": "முழு மயக்கம்",
        "regional": "பிராந்திய மயக்கம்",
        "local": "உள்ளூர் மயக்கம்",
        "spinal": "முதுகுத்தண்டு மயக்கம்",
        "epidural": "எபிட்யூரல் மயக்கம்",
        "sedation": "தூக்க மருந்து",
        "none": "இல்லை",
        "unknown": "தெரியாது"
      },
      "laterality": {
        "left": "இடது",
        "right": "வலது",
        "bilateral": "இரு பக்கம்"
      },
      "toast": {
        "added": "அறுவை சிகிச்சை வரலாறு உள்ளீடு சேர்க்கப்பட்டது",
        "addFailed": "அறுவை சிகிச்சை வரலாறு உள்ளீடு சேர்க்க முடியவில்லை",
        "procedureNameRequired": "செயல்முறை பெயர் அவசியம்"
      }
    },
    "referralManagement": {
      "title": "பரிந்துரைகள்",
      "addButton": "புதிய பரிந்துரை",
      "refresh": "புதுப்பிக்கவும்",
      "loading": "பரிந்துரைகள் ஏற்றப்படுகிறது...",
      "errorState": "பரிந்துரைகளை ஏற்ற முடியவில்லை.",
      "emptyState": "இந்த நோயாளிக்கு பரிந்துரைகள் இல்லை.",
      "emptyStateFiltered": "தேர்ந்தெடுக்கப்பட்ட நிலையுடன் பொருந்தும் பரிந்துரைகள் இல்லை.",
      "ariaFilterStatus": "நிலையின் அடிப்படையில் பரிந்துரைகளை வடிகட்டு",
      "externalBadge": "வெளி",
      "filterStatus": {
        "allLabel": "அனைத்து நிலைகள்"
      },
      "table": {
        "type": "வகை",
        "reason": "காரணம்",
        "specialty": "சிறப்புத்துறை",
        "priority": "முன்னுரிமை",
        "status": "நிலை",
        "requested": "கோரப்பட்டது",
        "target": "இலக்கு"
      },
      "form": {
        "title": "புதிய பரிந்துரை",
        "labels": {
          "referralType": "பரிந்துரை வகை",
          "priority": "முன்னுரிமை",
          "specialty": "சிறப்புத்துறை",
          "reason": "காரணம்",
          "targetDate": "இலக்கு தேதி",
          "clinicalNotes": "மருத்துவ குறிப்புகள்",
          "optional": "விருப்பத்தேர்வு"
        },
        "placeholders": {
          "reason": "பரிந்துரைக்கான காரணம்",
          "clinicalNotes": "கூடுதல் மருத்துவ குறிப்புகள்..."
        },
        "selectReferralTypePlaceholder": "வகையைத் தேர்ந்தெடுக்கவும்...",
        "selectSpecialtyPlaceholder": "சிறப்புத்துறையைத் தேர்ந்தெடுக்கவும்...",
        "buttons": {
          "create": "பரிந்துரை உருவாக்கு",
          "cancel": "ரத்து"
        }
      },
      "referralType": {
        "consultation": "ஆலோசனை",
        "transfer": "பராமரிப்பு மாற்றம்",
        "second-opinion": "இரண்டாம் கருத்து",
        "diagnostic": "நோய் கண்டறிதல்",
        "therapeutic": "சிகிச்சை"
      },
      "priority": {
        "routine": "வழக்கமான",
        "urgent": "அவசர",
        "stat": "STAT"
      },
      "status": {
        "draft": "வரைவு",
        "submitted": "சமர்ப்பிக்கப்பட்டது",
        "accepted": "ஏற்றுக்கொள்ளப்பட்டது",
        "scheduled": "திட்டமிடப்பட்டது",
        "completed": "முடிந்தது",
        "cancelled": "ரத்து செய்யப்பட்டது"
      },
      "toasts": {
        "createSuccess": "பரிந்துரை உருவாக்கப்பட்டது",
        "createFailed": "பரிந்துரை உருவாக்க முடியவில்லை",
        "validationFailed": "பரிந்துரை வகை மற்றும் காரணம் அவசியம்"
      }
    }
  },
  "consents": {
    "title": "Consents",
    "grant": "Grant consent",
    "revoke": "Revoke",
    "confirmRevoke": "Revoke this consent? This records a revocation event and cannot be undone.",
    "loading": "Loading consents…",
    "loadError": "Failed to load consents.",
    "empty": "No consent records for this patient.",
    "table": {
      "scope": "Scope",
      "category": "Category",
      "decision": "Decision",
      "status": "Status",
      "effective": "Effective",
      "recorded": "Recorded",
      "actions": "Actions",
      "history": "Event history"
    },
    "toast": {
      "revoked": "Consent revoked.",
      "revokeFailed": "Failed to revoke consent."
    },
    "scope": {
      "patientPrivacy": "Patient privacy",
      "research": "Research",
      "treatment": "Treatment",
      "adr": "Adverse drug reaction"
    },
    "decision": {
      "permit": "Permit",
      "deny": "Deny"
    },
    "status": {
      "draft": "Draft",
      "proposed": "Proposed",
      "active": "Active",
      "rejected": "Rejected",
      "inactive": "Inactive",
      "enteredInError": "Entered in error"
    },
    "eventType": {
      "granted": "Granted",
      "revoked": "Revoked",
      "evaluated": "Evaluated",
      "accessGranted": "Access granted",
      "accessDenied": "Access denied"
    },
    "events": {
      "loading": "Loading history…",
      "empty": "No events recorded."
    },
    "form": {
      "title": "Grant consent",
      "submit": "Grant consent",
      "savedSuccess": "Consent recorded.",
      "saveError": "Failed to record consent."
    },
    "fields": {
      "scope": "Scope",
      "decision": "Decision",
      "category": "Category",
      "categoryPlaceholder": "e.g. medical-records, imaging",
      "performer": "Performer",
      "performerPlaceholder": "e.g. Patient/123 or Practitioner/45",
      "purpose": "Purpose",
      "dataClass": "Data class",
      "effectiveFrom": "Effective from",
      "effectiveTo": "Effective to",
      "notes": "Notes"
    }
  },
  "pregnancy": {
    "title": "Pregnancy & Lactation Screening",
    "currentHeading": "Current status",
    "recordHeading": "Record a status",
    "historyHeading": "History",
    "pregnancyLabel": "Pregnancy",
    "lactationLabel": "Lactation",
    "eddLabel": "Estimated due date",
    "sourceLabel": "Source",
    "notesLabel": "Notes",
    "recordButton": "Record status",
    "recordedOn": "Recorded {{date}}",
    "eddOn": "Estimated due date {{date}}",
    "outOfDate": "Out of date",
    "neverAsked": "Never asked",
    "notRecorded": "Not recorded",
    "noHistory": "No screening has been recorded for this patient.",
    "savedSuccess": "Screening status recorded",
    "saveError": "Could not record the screening status",
    "status": {
      "pregnant": "Pregnant",
      "notPregnant": "Not pregnant",
      "unknown": "Not known",
      "declined": "Declined to answer",
      "notApplicable": "Not applicable"
    },
    "lactationStatus": {
      "lactating": "Lactating",
      "notLactating": "Not lactating",
      "unknown": "Not known",
      "declined": "Declined to answer",
      "notApplicable": "Not applicable"
    },
    "source": {
      "patientReported": "Patient reported",
      "clinician": "Clinician",
      "lab": "Laboratory"
    },
    "columns": {
      "recordedAt": "Recorded",
      "pregnancy": "Pregnancy",
      "lactation": "Lactation",
      "edd": "Due date",
      "source": "Source",
      "notes": "Notes"
    },
    "errors": {
      "notesTooLong": "Notes must be 1000 characters or fewer",
      "eddOnlyWhenPregnant": "An estimated due date applies only to a pregnant status"
    }
  },
  "nursingAssessment": {
    "title": "Nursing Assessment",
    "subtitle": "The Morse and Braden scores recorded here update this patient's risk badges.",
    "assessmentType": "Assessment type",
    "type": {
      "admission": "Admission",
      "shift": "Shift",
      "focused": "Focused",
      "discharge": "Discharge"
    },
    "levelOfConsciousness": "Level of consciousness",
    "loc": {
      "alert": "Alert",
      "drowsy": "Drowsy",
      "lethargic": "Lethargic",
      "confused": "Confused",
      "unresponsive": "Unresponsive"
    },
    "mobilityLevel": "Mobility",
    "mobility": {
      "independent": "Independent",
      "assistiveDevice": "Assistive device",
      "assistOfOne": "Assist of one",
      "assistOfTwo": "Assist of two",
      "bedbound": "Bedbound"
    },
    "fallRiskFactors": "Fall risk factors",
    "fallRiskFactorsPlaceholder": "e.g. unsteady gait, IV pole, sedation",
    "pressureInjuryPresent": "Pressure injury already present",
    "painAssessment": "Pain assessment",
    "painPlaceholder": "Site, character, score, intervention",
    "generalNotes": "General notes",
    "save": "Save assessment",
    "saving": "Saving…",
    "saved": "Assessment recorded",
    "saveFailed": "Could not record the assessment",
    "notClinical": "Your account has no clinical identity, so it cannot sign a nursing assessment.",
    "history": "Previous assessments",
    "historyEmpty": "No assessments recorded for this encounter yet.",
    "bands": "Fall: {{fall}} · Pressure: {{pressure}}",
    "notScored": "not scored"
  },
  "duplicates": {
    "title": "Duplicate Review",
    "subtitle": "Candidate duplicate records found by the matching scanner. Review each pair and merge, or record that they are different people.",
    "noPermission": "You do not have permission to review duplicate patient records.",
    "loading": "Loading candidates...",
    "loadFailed": "Could not load the duplicate worklist.",
    "empty": "No candidates to review.",
    "dismissed": "Decision recorded.",
    "dismissFailed": "Could not record the decision.",
    "prev": "Previous",
    "next": "Next",
    "pageOf": "Page {{page}} of {{totalPages}}",
    "columns": {
      "score": "Score",
      "patients": "Records",
      "matchedOn": "Matched on",
      "detected": "Detected",
      "actions": "Actions"
    },
    "filters": {
      "status": "Review status",
      "minScore": "Min score"
    },
    "status": {
      "pending": "Pending",
      "reviewed": "Reviewed",
      "merged": "Merged",
      "not_duplicate": "Not a duplicate",
      "ignored": "Ignored"
    },
    "confidence": {
      "very_high": "Very high",
      "high": "High",
      "medium": "Medium",
      "low": "Low"
    },
    "matchedField": {
      "nameMatch": "Name",
      "dobMatch": "Date of birth",
      "genderMatch": "Gender",
      "nationalIdMatch": "National ID",
      "phoneMatch": "Phone",
      "addressMatch": "Address"
    },
    "actions": {
      "review": "Review",
      "dismiss": "Not a duplicate"
    },
    "dismissDialog": {
      "title": "Record a review decision",
      "body": "{{name1}} ({{mrn1}}) and {{name2}} ({{mrn2}}) will be removed from the worklist.",
      "reasonHelp": {
        "not_duplicate": "These are different people. The pair will not return unless the matching evidence materially improves.",
        "ignored": "Do not action this pair for now. Same suppression rule applies."
      },
      "notesPlaceholder": "Notes (optional)",
      "cancel": "Cancel",
      "confirm": "Record decision"
    },
    "restricted": {
      "title_one": "நீங்கள் பார்க்க முடியாத நோயாளியை உள்ளடக்கிய {{count}} இணை உள்ளது",
      "title_other": "நீங்கள் பார்க்க முடியாத நோயாளிகளை உள்ளடக்கிய {{count}} இணைகள் உள்ளன",
      "body": "உங்கள் நோயாளிகளில் ஒருவர் வேறு மையத்தின் பதிவுடன் நகலாக இருக்கலாம். அதை தீர்மானிக்க உங்கள் அணுகலுக்கு வெளியே உள்ள நோயாளியைப் பார்க்க வேண்டியிருப்பதால் அந்த இணை பட்டியலில் இல்லை — சுகாதாரத் தகவல் மேலாண்மைத் துறையை மதிப்பாய்வு செய்யக் கேளுங்கள்."
    }
  },
  "__review_duplicateReview": "Duplicate-review worklist copy — ships English pending market sign-off; 'merge' vs 'link' is a records-management register that differs by market.",
  "recordExport": {
    "button": "பதிவை ஏற்றுமதி செய்",
    "exporting": "ஏற்றுமதி செய்யப்படுகிறது…",
    "success": "பதிவு ஏற்றுமதி செய்யப்பட்டது",
    "failed": "ஏற்றுமதி தோல்வி — எதுவும் பதிவிறக்கப்படவில்லை",
    "tooltip": "இந்த நோயாளியின் முழுமையான பதிவை எடுத்துச்செல்லக்கூடிய கோப்பாகப் பதிவிறக்கவும்"
  },
  "device": {
    "addTitle": "பொருத்து சாதனத்தைப் பதிவு செய்க",
    "editTitle": "அகற்றலைப் பதிவு செய்க",
    "deviceName": "சாதனத்தின் பெயர்",
    "deviceNamePlaceholder": "எ.கா., Evera MRI ICD, மருந்து பூசிய ஸ்டென்ட்",
    "deviceNameTooLong": "சாதனத்தின் பெயர் 512 எழுத்துகளுக்கு மிகாமல் இருக்க வேண்டும்",
    "deviceType": "சாதன வகை",
    "deviceTypePlaceholder": "எ.கா., இதயத் துடிப்பூக்கி, ஸ்டென்ட், செயற்கை உறுப்பு",
    "udi": "UDI",
    "udiPlaceholder": "தனித்துவ சாதன அடையாளக் குறி",
    "deviceCode": "சாதனக் குறியீடு",
    "deviceCodeSystem": "குறியீட்டு முறை",
    "deviceCodeSystemPlaceholder": "எ.கா., GMDN, SNOMED CT",
    "manufacturer": "உற்பத்தியாளர்",
    "modelNumber": "மாதிரி",
    "lotNumber": "தொகுதி எண்",
    "serialNumber": "வரிசை எண்",
    "implantDate": "பொருத்திய தேதி",
    "explantDate": "அகற்றிய தேதி",
    "status": "நிலை",
    "statusOptions": {
      "active": "செயலில்",
      "inactive": "செயலற்றது",
      "explanted": "அகற்றப்பட்டது"
    },
    "mriSafety": "MRI பாதுகாப்பு",
    "mriSafetyOptions": {
      "safe": "பாதுகாபபானது",
      "conditional": "நிபந்தனையுடன்",
      "unsafe": "பாதுகாப்பற்றது",
      "unknown": "தொரியவில்லை"
    },
    "notes": "குறிப்புகள்",
    "notesPlaceholder": "கூடுதல் குறிப்புகள்...",
    "savedSuccess": "சாதனம் வெற்றிகரமாகப் பதிவு செய்யப்பட்டது",
    "saveError": "சாதனத்தைப் பதிவு செய்ய முடியவில்லை",
    "updatedSuccess": "அகற்றல் வெற்றிகரமாகப் பதிவு செய்யப்பட்டது",
    "updateError": "அகற்றலைப் பதிவு செய்ய முடியவில்லை",
    "explantRequiresDate": "அகற்றப்பட்ட சாதனத்திற்கு அகற்றிய தேதி தேவை",
    "explantBeforeImplant": "அகற்றிய தேதி பொருத்திய தேதிக்கு முன் இருக்க முடியாது"
  },
  "devices": {
    "pageTitle": "பொருத்து சாதனங்கள்",
    "addDevice": "சாதனத்தைப் பதிவு செய்க",
    "loading": "சாதனங்கள் ஏற்றப்படுகின்றன...",
    "loadError": "சாதனத் தகவலை ஏற்ற முடியவில்லை.",
    "empty": {
      "title": "பொருத்து சாதனங்கள் இல்லை",
      "body": "இந்த நோயாளிக்கு எந்தச் சாதனமும் பதிவு செய்யப்படவில்லை."
    },
    "sections": {
      "active": "செயலில் உள்ள சாதனங்கள் ({{count}})",
      "history": "அகற்றப்பட்டவை / செயலற்றவை ({{count}})"
    },
    "fields": {
      "udi": "UDI",
      "manufacturer": "உற்பத்தியாளர்",
      "implanted": "பொருத்தியது",
      "explanted": "அகற்றியது",
      "mriSafety": "MRI பாதுகாப்பு",
      "recorded": "பதிவு"
    },
    "recordExplant": "அகற்றலைப் பதிவு செய்க",
    "explantTooltip": "இந்தச் சாதனத்தின் அகற்றலைப் பதிவு செய்க",
    "removeTooltip": "பதிவை நீக்கு",
    "removedSuccess": "சாதனப் பதிவு நீக்கப்பட்டது",
    "removeError": "சாதனப் பதிவை நீக்କ முடியவில்லை",
    "confirmDeleteTitle": "நீக்கத்தை உறுதி செய்க",
    "confirmDeleteMessage": "பட்டியலிலிருந்து \"{{name}}\" ஐ நீக்ୟவா? தவறாகப் பதிவு செய்தவற்றை மட்டும் நீக்குக — உடலிலிருந்து அகற்றலைப் பதிவு செய்ய அகற்றலைப் பதிவு செய்க என்பதைப் பயன்படுத்துக.",
    "confirmLabel": "உறுதி"
  },
  "ccdaImports": {
    "title": "C-CDA இறக்குமதி",
    "subtitle": "சரிபார்ப்புக்காகப் பெறப்பட்ட ஆவணங்கள். இறக்குமதியைத் திறந்து ஒவ்வொரு உள்ளீட்டையும் மதிப்பாய்வு செய்து பதிவில் சேர்க்கவும்.",
    "empty": "இந்த நோயாளிக்கு இறக்குமதி ஆவணங்கள் எதுவும் இல்லை.",
    "loadError": "இறக்குமதிகளை ஏற்ற முடியவில்லை.",
    "received": "பெறப்பட்டது",
    "docType": "வகை",
    "status": "நிலை",
    "pending": "நிலுவை",
    "entries": "உள்ளீடுகள்",
    "match": "பொருத்தம்",
    "mismatch": "ID பொருந்தவில்லை",
    "statuses": {
      "pending": "நிலுவை",
      "reviewed": "மதிப்பாய்வு செய்யப்பட்டது",
      "dismissed": "நிராகரிக்கப்பட்டது"
    },
    "docTypes": {
      "ccd": "CCD",
      "referral-note": "பரிந்துரை குறிப்பு",
      "discharge-summary": "மருத்துவமனை வெளியேற்ற சுருக்கம்",
      "other": "மற்றவை"
    }
  },
  "ccdaReview": {
    "title": "இறக்குமதி #{{id}}",
    "back": "இறக்குமதி பட்டியலுக்குத் திரும்பு",
    "loadError": "இந்த இறக்குமதியை ஏற்ற முடியவில்லை.",
    "mismatchWarning": "அனுப்புநர் அடையாளங்கள் இந்த நோயாளியுடன் பொருந்தவில்லை. ஏற்பதற்கு முன் ஆவணம் இவருடையது என்பதை உறுதிப்படுத்தவும்.",
    "unnamed": "பெயரிடப்படாத உள்ளீடு",
    "accept": "ஏற்கவும்",
    "reject": "நிராகரிக்கவும்",
    "accepted": "உள்ளீடு பதிவில் இணைக்கப்பட்டது",
    "rejected": "உள்ளீடு நிராகரிக்கப்பட்டது",
    "alreadyReviewed": "வேறு ஒருவர் ஏற்கனவே மதிப்பாய்வு செய்துவிட்டார் — கீழே புதுப்பிக்கப்பட்டது",
    "reviewError": "மதிப்பாய்வு தோல்வி",
    "confirmAcceptTitle": "பதிவில் ஏற்கவா?",
    "confirmAcceptMessage": "“{{name}}” இந்த நோயாளியின் பதிவில் சேர்க்கப்படும்.",
    "confirmRejectTitle": "இந்த உள்ளீட்டை நிராகரிக்கவா?",
    "confirmRejectMessage": "“{{name}}” வரிசையிலிருந்து நீக்கப்படும். மூல ஆவணம் கோப்பில் இருக்கும்.",
    "sections": {
      "problem": "பிரச்சனைகள்",
      "medication": "மருந்துகள்",
      "allergy": "ஒவ்வாமை"
    },
    "statuses": {
      "accepted": "ஏற்கப்பட்டது",
      "rejected": "நிராகரிக்கப்பட்டது"
    }
  }
}
